export default "__VITE_ASSET__9d2c96e8__"